import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Pin = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24.788 15.125L22.875 13.225C22.312 12.662 22 11.9 22 11.1V8H23C24.65 8 26 6.65 26 5C26 3.35 24.65 2 23 2H9C7.35 2 6 3.35 6 5C6 6.65 7.35 8 9 8H10V11.1C10 11.9 9.687 12.65 9.125 13.225L7.213 15.125C6.551 15.787 6.125 16.65 6.025 17.538C5.9 18.663 6.262 19.8 7.012 20.651C7.775 21.514 8.862 22.001 9.999 22.001H14.999V29.001C14.999 29.551 15.449 30.001 15.999 30.001C16.549 30.001 16.999 29.551 16.999 29.001V22.001H21.999C23.136 22.001 24.224 21.513 24.974 20.664C25.736 19.814 26.099 18.676 25.962 17.551C25.875 16.651 25.45 15.801 24.787 15.126L24.788 15.125ZM23.488 19.325C23.101 19.75 22.563 20 22 20H10C9.437 20 8.887 19.75 8.512 19.325C8.125 18.887 7.949 18.337 8.012 17.775C8.062 17.325 8.287 16.888 8.625 16.55L10.537 14.65C11.475 13.687 12 12.437 12 11.1V6H9C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4H23C23.55 4 24 4.45 24 5C24 5.55 23.55 6 23 6H20V11.1C20 12.438 20.525 13.688 21.462 14.637L23.362 16.537C23.712 16.887 23.925 17.325 23.975 17.762C24.05 18.337 23.875 18.899 23.487 19.325H23.488Z" />
	</svg>
);

export default Pin;
